// extracted by mini-css-extract-plugin
export default {"loadingScreen__Spinner":"LoadingScreen_loadingScreen__Spinner__6zdXH","slideUp":"LoadingScreen_slideUp__8DyAR","slideDown":"LoadingScreen_slideDown__VISxb"};